import {
  ProductRevivalApiClient,
  type RevivalRequest,
  type RevivalTransport,
} from "@medicorepay/shared";
import apiClient from "@/services/api-client";

const adminAxiosTransport: RevivalTransport = async <T>(
  request: RevivalRequest,
): Promise<T> => {
  const response = await apiClient.request<T>({
    url: request.path.replace(/^\/admin/, ""),
    method: request.method,
    headers: request.headers,
    params: request.query,
    data: request.body,
    responseType: request.responseType,
    timeout: request.timeoutMs,
  });
  return response.data;
};

export const productRevivalApi = new ProductRevivalApiClient(
  "",
  adminAxiosTransport,
);
